import { errorNotification } from "Components/MyNotification";
import UsersApi from "./UsersApi";

export const getAllUsersToSelect = async (search) => {
  try {
    const result = await UsersApi.getAll(1, search);
    if (result.status === "success") {
      return result.dto.data.map((item) => ({
        value: JSON.stringify(item) + `___` + item.id,
        label: item.name,
      }));
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};
